import { FC } from 'react'

import { Navigate } from 'react-router-dom'
import { Routes } from 'common/constants'
import { MeanOfCommunicationSkeleton } from 'components/mean-of-communication-skeleton'

import { MeanOfCommunicationView } from './MeanOfCommunicationView'
import { MeansOfCommunicationAdapter } from './MeansOfCommunication.types'
import { MeansOfCommunicationList } from './MeansOfCommunicationList'

interface MeansOfCommunicationProps {
  adapter: MeansOfCommunicationAdapter
}

export const MeansOfCommunication: FC<MeansOfCommunicationProps> = ({ adapter }) => {
  if (adapter.status === 'loading') return <MeanOfCommunicationSkeleton />

  if (adapter.status === 'error')
    return <Navigate to={Routes.ERROR} state={{ goTo: Routes.ROOT }} replace />

  return (
    <MeansOfCommunicationList
      isDontDisturbBottomsheetVisible={adapter.isDontDisturbBottomsheetVisible}
      onCloseDontDisturbBottomsheet={adapter.onCloseDontDisturbBottomsheet}
    >
      {adapter.methods.map(({ icon, id, isActive, isDisabled, isDontDisturb, name, onSwitch }) => (
        <MeanOfCommunicationView
          key={id}
          icon={icon}
          name={name}
          isActive={isActive}
          isDisabled={isDisabled}
          isDontDisturb={isDontDisturb}
          onSwitch={onSwitch}
        />
      ))}
    </MeansOfCommunicationList>
  )
}
